import React, { Component } from "react";
import "./Footer.scss";
import { 
  trackSocialMediaClick, 
  trackFooterLinkClick 
} from "../utils/analytics";

class Footer extends Component {
  handleSocialClick = (networkName, url) => {
    trackSocialMediaClick(networkName, url);
  };

  handleFooterLinkClick = (linkText, url) => {
    trackFooterLinkClick(linkText, url);
  };
  render() {
    if (this.props.sharedBasicInfo) {
      var networks = this.props.sharedBasicInfo.social.map((network) => {
        return (
          <a
            key={network.name}
            href={network.url}
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
            onClick={() => this.handleSocialClick(network.name, network.url)}
          >
            <i className={network.class}></i>
            <span className="social-tooltip">{network.name}</span>
          </a>
        );
      });
    }

    return (
      <footer className="elegant-footer">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand">
              <div className="brand-logo">
                <span className="brand-initial">
                  {this.props.sharedBasicInfo
                    ? this.props.sharedBasicInfo.name.charAt(0)
                    : "P"}
                </span>
              </div>
              <div className="brand-info">
                <h3 className="brand-name">
                  {this.props.sharedBasicInfo
                    ? this.props.sharedBasicInfo.name
                    : "Portfolio"}
                </h3>
                <p className="brand-tagline">
                  Crafting digital experiences with passion & precision
                </p>
              </div>
            </div>

            <div className="footer-links">
              <div className="links-section">
                <h4>Quick Links</h4>
                <ul>
                  <li>
                    <a 
                      href="#home"
                      onClick={() => this.handleFooterLinkClick('Home', '#home')}
                    >
                      Home
                    </a>
                  </li>
                  <li>
                    <a 
                      href="#about"
                      onClick={() => this.handleFooterLinkClick('About', '#about')}
                    >
                      About
                    </a>
                  </li>
                  <li>
                    <a 
                      href="#web-projects"
                      onClick={() => this.handleFooterLinkClick('Web Projects', '#web-projects')}
                    >
                      Web Projects
                    </a>
                  </li>
                  <li>
                    <a 
                      href="#mobile-projects"
                      onClick={() => this.handleFooterLinkClick('Mobile Projects', '#mobile-projects')}
                    >
                      Mobile Projects
                    </a>
                  </li>
                  <li>
                    <a 
                      href="#skills"
                      onClick={() => this.handleFooterLinkClick('Skills', '#skills')}
                    >
                      Skills
                    </a>
                  </li>
                  <li>
                    <a 
                      href="#experience"
                      onClick={() => this.handleFooterLinkClick('Experience', '#experience')}
                    >
                      Experience
                    </a>
                  </li>
                </ul>
              </div>

              <div className="links-section">
                <h4>Connect</h4>
                <div className="social-links">{networks}</div>
              </div>
            </div>
          </div>

          <div className="footer-divider">
            <div className="divider-line"></div>
            <div className="divider-decoration">
              <span className="decoration-dot"></span>
              <span className="decoration-dot"></span>
              <span className="decoration-dot"></span>
            </div>
            <div className="divider-line"></div>
          </div>

          <div className="footer-bottom">
            <div className="footer-copyright">
              <p>
                © {new Date().getFullYear()}{" "}
                {this.props.sharedBasicInfo
                  ? this.props.sharedBasicInfo.name
                  : "Portfolio"}
                . All rights reserved.
              </p>
            </div>
            <div className="footer-signature">
              <p>
                <span className="heart-beat">❤️</span> Made with love &{" "}
                <span className="coffee-steam">☕</span>
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
